export default "__VITE_ASSET__B2WI1kz1__"